import { ChevronRight } from "lucide-react";

import { Breadcrumbs } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useBreadcrumbs } from "@src/features/getInspired/hooks/useBreadcrumbs";

export const IgPageContentBreadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs();

  return (
    <Grid>
      <Breadcrumbs
        sx={{
          "& .MuiBreadcrumbs-li": { maxWidth: "410px" },
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        separator={<ChevronRight size={16} />}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Grid>
  );
};
